import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('tab/:any', form);
Router.get('tab', index);
